import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class PeriodTypeInfo  {
    _originalTypeClassName = "zERP.BO.PeriodTypeInfo";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
PeriodTypeInfo.translate = translateService;
}
this.info = null;
this.PeriodTypeInfoKey = null;
this._key = this.PeriodTypeInfoKey = 0; 
}

static translate: TranslateService;
_key: any;
info:any;
private _PeriodTypeInfoKey:any;
get PeriodTypeInfoKey(): any {
    return this._PeriodTypeInfoKey;
  }
set PeriodTypeInfoKey(value: any) {
    this._PeriodTypeInfoKey = value;
    this._key = value;
  }

static insertInfo(info_: any): any{let pti = new Domain.PeriodTypeInfo();
pti.info = info_;
return pti;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.PeriodTypeInfoKey == null || $this.PeriodTypeInfoKey == 0;
            }


}